import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontIcon, TextField } from 'react-md';

// import { debounce } from 'lodash-es';

class TextFilter extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    icon: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    icon: 'search',
    value: undefined,
  };

  constructor(props) {
    super(props);

    const { value } = props;
    this.state = {
      selectedValue: value,
    };
  }

  handleChange = val => {
    const { name, onFilterChange } = this.props;
    this.setState({
      selectedValue: val,
    });
    // debounce(onFilterChange({ values: val, name }), 500);
    onFilterChange({ values: val, name });
  };

  render() {
    const { label, placeholder, name, icon } = this.props;
    const { selectedValue } = this.state;
    const leftIcon = () => <FontIcon>{icon}</FontIcon>;

    return (
      <TextField
        id={name}
        name={name}
        label={label || 'Filter by Id or Subscriber'}
        placeholder={placeholder || 'eg. Paul Smith or 34G78... '}
        type="text"
        // rightIcon=<FontIcon>{icon}</FontIcon>
        leftIcon={leftIcon()}
        size={40}
        value={selectedValue}
        fullWidth={false}
        style={{ marginBottom: '1em' }}
        onChange={this.handleChange}
      />
    );
  }
}

export default TextFilter;
